export default {
	methods: {
		$_hasAccessToModule(module) {
			return this.$store.getters.hasAccessToModule(module);
		},
		$_hasAccessToFeature(featureId, action) {
			return this.$store.getters['privileges/hasFeatureAccess'](featureId, action);
		},
		$_hasAccessToEmployee(loggedInEmployee, employeeId) {
			if (employeeId === null) {
				return true;
			}

			if (loggedInEmployee.id === employeeId) {
				return true;
			}

			if (loggedInEmployee.isAdmin) {
				return true;
			}

			if (loggedInEmployee.underlings != null && loggedInEmployee.underlings.length > 0) {
				return loggedInEmployee.underlings.includes(employeeId);
			}

			return false;
		},
		$_hasAccessToEditEmployee(loggedInEmployee, employeeId) {
			if (loggedInEmployee.isAdmin) return true;

			const isSelf = loggedInEmployee.id === employeeId;

			return this.$_hasAccessToEmployee(loggedInEmployee, employeeId) && !isSelf;
		},
		// Global filtering mechanism for employees
		$_getFilteredEmployeeIds(loggedInEmployee, { search, tags, matchAllTags, includeInactive, departmentId }) {
			let filtered = [...this.$store.getters['employees/employeesMini']];

			// Limit employees to the ones that the logged in employee has access to
			if (!loggedInEmployee.isAdmin) {
				if (loggedInEmployee.underlings != null && loggedInEmployee.underlings.length > 0) filtered = filtered.filter(x => x.id === loggedInEmployee.id || loggedInEmployee.underlings.includes(x.id));
				else return filtered.filter(x => x.id === loggedInEmployee.id).map(x => x.id);
			}

			// Tags
			if (tags.length > 0) {
				if (matchAllTags) {
					filtered = filtered.filter(employee => tags.every(selectedTag => employee.tags.some(employeeTag => employeeTag.name.toLowerCase() === selectedTag.toLowerCase())));
				} else {
					filtered = filtered.filter(employee => tags.some(selectedTag => employee.tags.some(employeeTag => employeeTag.name.toLowerCase() === selectedTag.toLowerCase())));
				}
			}

			// Department
			if (departmentId) {
				filtered = filtered.filter(x => x.department != null && x.department.id === departmentId);
			}

			// Search
			if (search) {
				filtered = filtered.filter(x => x.fullName.toLowerCase().includes(search.toLowerCase()));
			}

			// Include Active?
			filtered = !includeInactive ? filtered.filter(x => x.isActive) : filtered;

			return filtered.map(x => x.id);
		}
	}
};
